<!--
Copyright (c) 2026 Antmicro <www.antmicro.com>

SPDX-License-Identifier: Apache-2.0
-->

<!-- eslint-disable max-len -->
<template>
    <svg height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" scale="0.83">
        <path
            d="M3.5868 13.7788C3.1171 13.3119 2.88229 13.0784 2.7328 12.6201C2.62619 12.2933 2.62616 11.7066 2.7328 11.3797C2.88233 10.9215 3.11763 10.6875 3.58827 10.2197C5.36624 8.45208 8.46924 6 11.9999 6C15.5305 6 18.6338 8.45208 20.4133 10.2211C20.8827 10.6877 21.1178 10.9219 21.2672 11.38C21.3738 11.7068 21.374 12.2938 21.2674 12.6206C21.1182 13.0779 20.8832 13.3114 20.4146 13.7772L20.4117 13.7803C18.6338 15.5478 15.5305 18 11.9999 18C8.46924 18 5.36624 15.5478 3.5868 13.7788Z"
            stroke="#ffffff"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M11.9999 14C13.1045 14 13.9999 13.1046 13.9999 12C13.9999 10.8954 13.1045 10 11.9999 10C10.8953 10 9.99989 10.8954 9.99989 12C9.99989 13.1046 10.8953 14 11.9999 14Z"
            stroke="#ffffff"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
    </svg>
</template>
